import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as S from "./styled.js";
const SearcherSkeletonButtonDesktop = ({ grow =false , variant ='adaptive' , counter =false , color , opacity  })=>/*#__PURE__*/ _jsxs(S.SearcherSkeletonContent, {
        "data-testid": "SearcherSkeletonButtonDesktop",
        $variant: variant,
        $grow: grow,
        className: "searcher-button",
        children: [
            counter && /*#__PURE__*/ _jsxs(S.SkeletonWrapper, {
                $grow: grow,
                children: [
                    /*#__PURE__*/ _jsx(S.SkeletonText, {
                        variant: "rectangular",
                        animation: "wave",
                        width: "55px",
                        height: "24px",
                        color: color,
                        opacity: opacity
                    }),
                    /*#__PURE__*/ _jsx(S.SkeletonText, {
                        variant: "rectangular",
                        animation: "wave",
                        width: "65px",
                        height: "16px",
                        color: color,
                        opacity: opacity
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(S.SearcherSkeletonButton, {
                variant: "rectangular",
                animation: "wave",
                height: "56px",
                color: color,
                opacity: opacity
            })
        ]
    });
export default SearcherSkeletonButtonDesktop;

//# sourceMappingURL=index.js.map